import React, { useEffect, useState } from 'react';
import { SwiperControl } from '../SwiperControl.js';
import { alfrescoTypes, listTypes } from '../../constants.js';
import NewVacationWidget from './NewVacationWidget.js';
import NewDocumentWidget from './NewDocumentWidget.js';

const NewWidgetsList = (props) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        const widgetItems = [
            () => <NewVacationWidget />,
            () => <NewDocumentWidget type={alfrescoTypes.certification} />
        ];
        if (props.showBusinessTrip) {
            widgetItems.push(() => <NewDocumentWidget type={alfrescoTypes.businessTrip} />);
        }
        if (props.showTransferRequest) {
            widgetItems.push(() => <NewDocumentWidget type={alfrescoTypes.transferRequest} />);
        }
        widgetItems.push(() => <NewDocumentWidget type={alfrescoTypes.details} />);
        setItems(widgetItems);

    }, []);

    return (<div className="new-widgets-list">
        <SwiperControl items={items} itemComponent={({ item }) => item()} showArrows={true} type={listTypes.Widgets} />
    </div>);
}

export default NewWidgetsList;